
import Layout from '../components/layout/layout.component.jsx'



function Cancel() {
    return (
        <Layout>
        <h1>Sorry to see you cancelled your Stripe payment!</h1>
        </Layout>
    )
}

export default Cancel;